import React from 'react'
import ColumnFlexBox from './ColumnFlexBox'
import RowFlexBox from './RowFlexBox'
import FlexBox from './FlexBox'

const DemographicsBox = ({children, className, style = {}, title = ''}) => {
  let DBClassName = 'demographics-box' + (className ? ' ' + className : '')
  let titleIcon = 'demographics-box-icon mini-dmp-icons ' + (className ? ' ' + className : '')
  return (
    <ColumnFlexBox className={DBClassName} width='initial' style={style}>
      <RowFlexBox>
        <FlexBox className='title'>
          <span className={titleIcon} />
          {title}
        </FlexBox>
      </RowFlexBox>
      {children}
    </ColumnFlexBox>
  )
}

export default DemographicsBox



// WEBPACK FOOTER //
// ../src/commons/components/SegmentsPopupContent/DemographicsBox.js